<template>
  <div data-qa="price_home">
    <div
      class="text-h6 text--text mb-1"
      data-qa="price_home_num"
    >
      {{ formattedPrice }}
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { getFormattedPrice } from 'www/utils'
import { computed } from 'vue'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  price?: number | null
}>()

const formattedPrice = computed(() => (
  getFormattedPrice(props.price, {
    prefix: t('от', options),
  })
))
</script>
